import { render } from "./EssayDetailView.vue?vue&type=template&id=6bf7123a&scoped=true"
import script from "./EssayDetailView.vue?vue&type=script&lang=js"
export * from "./EssayDetailView.vue?vue&type=script&lang=js"

import "./EssayDetailView.vue?vue&type=style&index=0&id=6bf7123a&scoped=true&lang=css"

import exportComponent from "/Users/priscillacancar/Documents/Coding/1) Engram-site/Engram/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bf7123a"]])

export default __exports__